<template>
  <div>
    <el-dialog
      :title="modalTitle"
      :visible.sync="visible"
      width="800px"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleBeforeClose"
    >
      <el-row class="title">
        <el-col style="color:#333">
          <span>当前项目：</span>{{ form.projectName }}
        </el-col>
      </el-row>
      <div class="content">
        <el-form :model="form" :rules="rules" label-width="130px" label-position="right" ref="formRef">
          <el-form-item required label="日期（单选）：" prop="workTime">
            <el-button @click="$refs.selectCalendar.open()" class="btn_c666">
              {{ showWorkTime }}
            </el-button>
          </el-form-item>
          <el-form-item label="选择工人：" prop="workNoList" v-if="form.recordType==='2'" ref="formSelectWorker" style="margin-bottom: 22px;">
            <el-button class="btn_c666" @click="$refs.selectWorker.open(form.workNoList)">选择工人 ></el-button>
            <span style="margin-left: 16px" v-if="workerInfoArr.length">已选择{{ workerInfoArr[0].name }}等{{form.workNoList.length}}人</span>
          </el-form-item>
          <el-form-item label="工程量：" prop="quantities" style="margin-bottom: 12px;">
            <el-input style="width: 340px;margin-right: 10px" v-model="form.quantities" placeholder="请填写工程量"
                      @input="Mixin_commonLimitInput('form.quantities',6,0,false);computedSalary()"></el-input>
            <el-button class="btn_c666" style="width: 100px"
                       @click="selectUnitShow = true">{{ form.quantitiesUnit }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>

          </el-form-item>
          <el-form-item label="单价：" prop="unitPrice">
            <el-input style="width: 450px;" v-model="form.unitPrice" placeholder="请填写单价"
                      @input="Mixin_commonLimitInput('form.unitPrice',6,2,true);computedSalary()">
              <template slot="append">元</template>
            </el-input>

          </el-form-item>
          <el-form-item label="工钱：" prop="salary" style="margin-bottom: 22px;">
            <el-input style="width: 450px;" v-model="form.salary" placeholder="请填写工钱"
                      @input="Mixin_commonLimitInput('form.salary',12,2,true)">
              <template slot="append">元</template>
            </el-input>

            <div class="tips">* 工钱根据工程量*单价计算得出，允许手动修改</div>
          </el-form-item>
          <el-form-item prop="remark" label="备注：" style="margin-bottom: 12px;">
            <el-input v-model="form.remark" placeholder="请填写备注" :maxlength="300"></el-input>
          </el-form-item>
          <el-form-item label="上传备注图片：" style="margin-bottom: 0;">
            <el-upload
              ref="upload"
              :action="actionURL"
              list-type="picture-card"
              class="upload"
              :on-success="onSuccess"
              :on-remove="onRemove"
              :on-exceed="onExceed"
              :before-upload="beforeUpload"
              accept=".jpg,.png,.jpeg"
              :limit="5"
              multiple
              :class="{hide_upload:this.form.picture.split(',').length>=5}"
            >
              <div class="upload_icon">
                <i class="el-icon-plus"></i>
                上传
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="flex_jc_center footer">
        <el-button @click="handleBeforeClose">取 消</el-button>
        <el-button @click="save" type="primary" style="margin-left:15px">保 存</el-button>
      </div>
    </el-dialog>

    <SelectCalendar ref="selectCalendar" :year="workYear" :math="workMonth" :redio="true"
                    :value.sync="form.workTime"></SelectCalendar>

    <!--  工程量单位弹窗  -->
    <SelectUnit :visible.sync="selectUnitShow" :value.sync="form.quantitiesUnit"></SelectUnit>

    <!--    选择工人-->
    <select-worker ref="selectWorker" @save="saveWorker"></select-worker>
  </div>
</template>

<script>
import {wokerForm} from '@/mixins/validate/work.js'
import {api} from "@/api/apiRecord"

export default {
  name: "addBaoWorkDialog",
  mixins: [wokerForm],
  components: {
    SelectCalendar: () => import("./selectCalendar.vue"), // 日历
    SelectUnit: () => import("./selectUnit"), // 工程量单位选择弹窗
    SelectWorker: ()=>import("./SelectWorker") // 选择工人
  },
  props: {
    visible: {
      type: Boolean
    },
    project: { // 项目信息对象
      type: [Object, undefined]
    },
    workRecordNo: { // 流水no
      type: String,
    }
  },
  data() {
    return {
      workerInfoArr:[],
      actionURL: `${process.env.VUE_APP_APITEAM}/file/addFiles`, // 图片上传地址
      form: {
        no: "",//包工流水no
        picture: "",//图片地址
        projectName: "",//项目名称
        projectNo: "",//包工流水no
        quantities: "", // 工程量
        quantitiesUnit: "平方米", // 工程量单位
        recordType: "",// 记账类型(1:个人,2班组)
        remark: "", // 备注
        salary: "", // 薪资
        unitPrice: "", // 工程量单价
        userNo: "",//用户no
        workTime: "",//工作时间
        workNoList:[]
      },
      selectUnitShow: false, // 工程量单位选择弹窗是否显示
      workYear: "", // 选中的年份
      workMonth: "", // 选中的月份
      rules: {
        salary: [{required: true, message: '请填写工钱'}],
        workNoList:[{required: true, message: '请选择工人',type: 'array'}]
      },
      list: ["平方米", "立方米", "吨", "米", "寸", "个", "次", "天", "块", "组", "台", "捆", "宗", "项", "株"], // 工程量单位列表
      loading:false
    }
  },
  mounted() {
    this.workYear = new Date().getFullYear()
    this.workMonth = new Date().getMonth() + 1
  },
  methods: {
    getToDay() {
      return `${new Date().getFullYear()}-` + `0${new Date().getMonth() + 1}`.substr(-2) + `-` + `0${new Date().getDate()}`.substr(-2)
    },
    handleBeforeClose() {
      this.$emit("update:visible", false)
      this.form.quantitiesUnit="平方米"
      this.form.picture=""
      this.$nextTick(()=>{
        this.form.workNoList=[]
        this.workerInfoArr=[]
      })
      this.$refs.upload.clearFiles()
      this.$refs.formRef.resetFields()
    },
    // 保存包工信息
    save() {
      if(this.loading) return
      this.loading=true
      this.$refs.formRef.validate(async valid => {
        if (!valid) return this.loading=false

        this.form.projectNo = this.project.no || this.project.projectNo
        this.form.projectName = this.project.projectName
        this.form.no=this.workRecordNo
        this.form.userNo = this.$store.getters.getUser.no
        if(this.form.recordType==='1'){
          delete this.form.workNoList
        }

        const delectArr = ['workerName','createTime','createUser','isDeleted','isEnable','updateUser','updateTime']
        delectArr.forEach(item=>{
          delete this.form[item]
        })
        const params = {...this.form}
        params.quantitiesUnit = String(this.list.findIndex(item => item === params.quantitiesUnit) + 1)
        const res = await api.workWrapAdd(params)
        if (res.data.code === 200) {
          this.$emit('close')
          this.$message.success('保存成功')
          this.handleBeforeClose()
        }else if(res.data.code === 500){
          this.$message.error('保存失败')
          this.loading=false
        }
      })
    },
    // 获取项目详情
    async getProjectDetail() {
      const params = {
        no:this.workRecordNo,
        type:this.$route.query.type?this.$route.query.type:'1'
      }
      const res = await api.workWrapDetail(params)
      if (res.data.code === 200) {
        const data = res.data.data
        this.form=Object.assign(this.form,data)
        const time = new Date(data.workTime)
        this.form.workTime = time.getFullYear()+'-'+('0'+(time.getMonth()+1)).substr(-2)+'-'+('0'+time.getDate()).substr(-2)

        this.form.quantitiesUnit=this.list[data.quantitiesUnit-1]
        this.form.picture = data.picture
        if(data.picture){
          this.$refs.upload.fileList= data.picture.split(',').map(item=>{
            return {url:item}
          })
        }
      }
    },
    // 图片上传成功
    onSuccess(response) {
      let arr = this.form.picture ? this.form.picture.split(',') : []
      arr.push(response.data[0].uuid)
      this.form.picture = arr.join()
    },
    // 删除图片
    onRemove(file) {
      const deleteImgUrl = file.response ? file.response.data[0].uuid : file.url
      let arr = this.form.picture ? this.form.picture.split(',') : []
      arr = arr.filter(item => {
        return item !== deleteImgUrl
      })
      this.form.picture = arr.join()
    },
    // 上传图片超过5张
    onExceed() {
      this.$message.warning('最多上传5张图片')
    },
    // 图片上传之前
    beforeUpload(file) {
      if (file.size / 1024 / 1024 >= 10) {
        this.$message.warning('只能上传10M以下的图片')
        return false
      }
    },
    // 计算工钱
    computedSalary(){
      const salary = this.form.quantities * this.form.unitPrice
      this.form.salary = salary == 0 ? "" : salary.toFixed(2)
    },
    /**
    * 保存选择的工人
    * @param v {Array} 选择的工人数组
    * */
    saveWorker(v,workerInfoArr){
      this.form.workNoList = v
      this.workerInfoArr = workerInfoArr
      this.$refs.formSelectWorker.validate()
    }
  },
  watch: {
    visible(val) {
      if (!val || !this.project) return
      this.loading=false

      if (this.workRecordNo) { // 编辑
        const recordType = this.$route.query.type?this.$route.query.type:'1'
        if(recordType==='2'){
          this.form.workNoList=this.project.workNoList
          this.form.operateNum=this.project.operateNum
          this.workerInfoArr=[{name:this.project.workerName}]
        }
        this.getProjectDetail()
        this.form.recordType=recordType
      } else { // 新增
        if (!this.projectNo) { // 新增设置项目no，项目名称
          this.form.projectNo = this.project.no
          this.form.projectName = this.project.projectName
        }

        if(this.$parent.day){
          this.form.workTime=String(this.$parent.day.cYear)+'-'+('0'+this.$parent.day.cMonth).substr(-2)+'-'+this.$parent.day.cDay
        }else{
          this.form.workTime = this.getToDay()
        }
      }
      this.form.recordType=this.$route.query.type?this.$route.query.type:'1'
    }
  },
  computed: {
    showWorkTime() {
      const time = this.form.workTime.split("-")
      return `${time[0]}年${time[1]}月${time[2]}日 >`
    },
    // 模态框标题
    modalTitle(){
      return (this.form.recordType==='1'?'个人':'班组')+'记工-包工'
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__footer {
  padding-bottom: 30px;
}
.el-button--primary {
  color: #fff;
  border-color: #b79255;
  background: #b79255;
  width: 58px;
  height: 34px;
  padding: 0 15px;
  font-size: 14px;
  &:hover,&:focus{
  color: #fff;
  border-color: #b79255;
  background: #b79255;
  }
  }
.upload {

  /deep/ .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
}

.content {
  padding: 20px 20px 0 10px;

  /deep/ .el-upload {
    width: 100px;
    height: 100px;
  }

  .upload_icon {
    width: 100px;
    height: 100px;
    line-height: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    i {
      margin-bottom: 10px;
      color: #0286DF;
    }
  }
}

.title {
  padding: 0 20px;
  background: #F5F7FA;
  line-height: 40px;
  font-size: 16px;

  span {
    color: #666;
    font-weight: normal;
  }
}

/deep/ .el-dialog__body {
  padding: 0;
}

/deep/ .el-dialog__footer {
  padding: 40px;
}

.bg_gold {
  background: #B79255;
}

.color_fff {
  color: #fff;
}

.tips {
  color: #969696;
  line-height: 20px;
  margin-top: 5px;
}

.calendar_wrap {
  padding: 30px 96px 0;

  > div {
    padding: 30px 20px;
    border: 1px solid #B79255;
    border-radius: 7px;
  }

  .time_wrap {
    margin-bottom: 20px;
  }
}

.hide_upload {
  /deep/ .el-upload {
    display: none;
  }
}

/deep/ .el-input__inner{
  height: 34px;
}

.el-button {
  padding: 9px 20px;
}

/deep/ .el-upload-list__item-status-label {
  display: none !important;
}

.btn_c666 {
  color:#666666 !important;
  border-color:#dcdfe6 !important;
  border-radius: 4px;
  &:hover{
    color:#666666 !important;
    border-color:#dcdfe6 !important;
  }
}
.footer {
  .el-button{
    padding: 9px 12px;
  }
}
.el-form-item{
  margin-bottom: 9px;
}
</style>
